import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'


export default class extends Controller {
  static targets = ["table"]

  datatableInstance = null

  connect() {
    this.initializeOrRefreshDataTable()
  }

  disconnect() {
    this.cleanup()
    document.removeEventListener("turbo:before-cache", this.cleanup.bind(this))
  }

  initializeOrRefreshDataTable() {
    if (this.hasTableTarget) {
      if (this.datatableInstance) {
        this.cleanup()
      }
      this.initDataTable();
    }
  }

  initDataTable() {
    this.datatableInstance = $(this.tableTarget).DataTable({
      processing: true,
      serverSide: true,
      filter: true,
      orderMulti: false,
      ajax: {
        url: this.data.get("source"),
        type: "GET",
        dataSrc: function(json) {
          return json.data.map(item => item[1])
        }
      },
      columns: [
        { data: "date_sort", visible: false, searchable: true },
        { data: "date_display", visible: true, searchable: false },
        { data: "note", visible: false, searchable: true },
        { data: "user", visible: false, searchable: true },
        { data: "student_name", visible: false, searchable: true },
        { data: "id", visible: false, searchable: true },
        { data: "icon_color", visible: false, searchable: false },
        { data: "category", visible: false, searchable: true },
        { data: "read", visible: false, searchable: false },
        { data: "share_or_transfer", visible: false, searchable: false },
        { data: "header", visible: false, searchable: false },
        { data: "sub_title", visible: false, searchable: false },
        { data: "url", visible: false, searchable: false }
      ],
      order: [[0, 'desc']],
      dom: '<"row"<"col-md-6"><"col-md-6">>rt<"row"<"col-md-12"ip>>',
      displayLength: 50,
      lengthMenu: [10, 25, 50, 75, 100],
      responsive: true,
      createdRow: function(row, data, dataIndex) {
        const obsId = data.id;
        const obsDateSort = data.date_sort;
        const obsDateDisplay = data.date_display;
        const note = data.note;
        const userFullName = data.user;
        const studentFullName = data.student_name;
        const iconColor = data.icon_color;
        const category = data.category;
        const isRead = data.read;
        const shareOrTransfer = data.share_or_transfer;
        const header = data.header;
        const subTitle = data.sub_title;
        const url = data.url;

        const notificationLink = url;

        const desktopContent = `
          <td class="hidden">${obsDateSort}</td>
          <td class="w-100 card mb-1 shadow-none border-radius-16px px-0 py-5px ${isRead ? 'background-white' : 'background-theme-4'} d-none d-lg-block">
            <div class="d-flex align-items-start py-10px px-5px">
              <a href="${notificationLink}" class="card-body ps-1 pt-0 pb-0 pe-1 d-flex align-items-start" data-id="${obsId}" data-action="${isRead ? '' : 'click->datatables--notification#setupNotificationClickHandler'}">
                <div class="w-15">
                  <p class="text-ft-12">
                    <span class="text-weight-600">
                      ${shareOrTransfer ? `<i class="far fa-bell fa-lg me-5px"></i>${header}` : studentFullName}
                    </span>
                    <br>
                    ${obsDateDisplay}
                    <br>
                    ${userFullName}
                  </p>
                </div>
                <div class="mx-2">
                  <div class="vr text-grey" style="height: 50px;"></div>
                </div>
                <div class="w-80">
                  <div class="d-flex">
                    ${shareOrTransfer ? `<p class="text-weight-600 text-ft-16 mb-5px">${subTitle}</p>` : `<img class="image-20-h" src="/icons/${iconColor}.svg" alt="icon couleur évaluation"/>
                      <p class="text-grey text-ft-12 mb-0 ms-5px">${category}</p>`}
                  </div>
                  <div class="mt-10px">
                    <p class="text-ft-16 mb-0">${note}</p>
                  </div>
                </div>
              </a>
            </div>
          </td>`;

        const mobileContent = `
          <td class="hidden">${obsDateSort}</td>
          <td class="w-100 card mb-1 shadow-none border-radius-16px ps-0 pt-0 pb-0 pe-0 ${isRead ? 'background-white' : 'background-theme-4'} d-block d-lg-none">
            <div class="d-flex flex-column justify-content-center py-10px px-5px">
              <div class="d-flex justify-content-between pe-10px">
                <div class="d-flex align-items-center">
                  <span class="text-weight-600 text-ft-12 ms-10px">${shareOrTransfer ? `<i class="far fa-bell fa-lg me-5px"></i>${header}` : studentFullName}</span>
                </div>
                <div>
                  <p class="text-ft-12 text-end">
                    ${obsDateDisplay}
                    <br>
                    ${userFullName}
                  </p>
                </div>
              </div>
              <hr class="mb-16px mt-8px mx-10px" style="height: 2px;"/>
              <a href="${notificationLink}" class="card-body ps-10px pt-0 pb-0 pe-1" data-id="${obsId}" data-action="${isRead ? '' : 'click->datatables--notification#setupNotificationClickHandler'}">
                <div class="d-flex">
                  ${shareOrTransfer ? `<p class="text-weight-600 text-ft-16 mb-5px">${subTitle}</p>` : `<img class="image-20-h" src="/icons/${iconColor}.svg" alt="icon"/>
                    <p class="text-grey text-ft-12 mb-0 ms-5px">${category}</p>`}
                </div>
                <div class="mt-10px">
                  <p class="text-ft-16 mb-0">${note}</p>
                </div>
              </a>
            </div>
          </td>`;

        $(row).html(desktopContent + mobileContent);
      },
      ...window.datatablesDefaults
    });
  }

  cleanup() {
    if (this.datatableInstance) {
      this.datatableInstance.destroy(true)
      this.datatableInstance.clear()
      this.datatableInstance = null
    }
  }

  async setupNotificationClickHandler(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const notificationId = target.dataset.id;
    const markAsReadUrl = `/notifications/${notificationId}/mark_as_read`
    const request = new FetchRequest('patch', markAsReadUrl, {})
    const response = await request.perform()
    if (response.ok) {
      target.removeAttribute('data-action')
      target.click()
    }
  }
}
